module.exports = __webpack_public_path__ + "img/footer-v4.ffd4e0a0.png";